

import React from 'react'
import { useSelector } from 'react-redux'
import MainPage from './MainPage'
import { ToastContainer } from 'react-toastify';
import Svgs from './Components/Other/Svgs'
import {Tracking_ID} from './config'
import ReactGA from 'react-ga';
function App(props) {
 
  ReactGA.initialize(Tracking_ID);
  const data = useSelector((state) => state)

  return (
    <>
      <Svgs></Svgs>
      <ToastContainer
        position="top-right"
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        autoClose={3000}
        style={{ "max-width": "500px", "width": "auto" }}
      ></ToastContainer>
      <MainPage></MainPage>
    </>

  )
}
export default (App);
